const etapas = [
  {
    num: '01',
    title: 'Mapa de Gargalos e Alavancas',
    desc: 'Diagnóstico completo do negócio. Identificamos onde a empresa perde dinheiro e onde pode crescer mais rápido.',
    icon: 'ri-map-2-line',
    color: 'text-violet-600',
    bg: 'bg-violet-50',
    border: 'border-violet-200',
  },
  {
    num: '02',
    title: 'Gestão e Estrutura Operacional',
    desc: 'Organização da empresa: papéis, responsabilidades, processos e rotinas operacionais definidos.',
    icon: 'ri-building-2-line',
    color: 'text-sky-600',
    bg: 'bg-sky-50',
    border: 'border-sky-200',
  },
  {
    num: '03',
    title: 'Organização Financeira',
    desc: 'Fluxo de caixa, DRE simplificado, margem de contribuição e ponto de equilíbrio sob controle.',
    icon: 'ri-money-dollar-circle-line',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
  },
  {
    num: '04',
    title: 'Estrutura Comercial',
    desc: 'Funil de vendas estruturado, scripts, métricas de conversão e previsibilidade de receita.',
    icon: 'ri-bar-chart-grouped-line',
    color: 'text-orange-600',
    bg: 'bg-orange-50',
    border: 'border-orange-200',
  },
  {
    num: '05',
    title: 'Inovação e Eficiência Empresarial',
    desc: 'Identificar novas oportunidades de crescimento e diferenciação competitiva.',
    icon: 'ri-lightbulb-flash-line',
    color: 'text-teal-600',
    bg: 'bg-teal-50',
    border: 'border-teal-200',
  },
  {
    num: '06',
    title: 'Inteligência Artificial Aplicada',
    desc: 'Aplicação de inteligência artificial e automações para escalar resultados com menos esforço.',
    icon: 'ri-robot-line',
    color: 'text-rose-600',
    bg: 'bg-rose-50',
    border: 'border-rose-200',
  },
  {
    num: '07',
    title: 'Jurídico para Empresas',
    desc: 'Contratos padronizados, documentos organizados e estrutura jurídica para proteger e blindar o negócio.',
    icon: 'ri-scales-3-line',
    color: 'text-indigo-700',
    bg: 'bg-indigo-50',
    border: 'border-indigo-200',
  },
];

export default function MetodoSection() {
  return (
    <section id="metodo" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-16">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-4">
            Como funciona
          </p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 leading-tight">
              O MÉTODO DE<br />
              <span className="text-amber-500">TRANSFORMAÇÃO</span>
            </h2>
            <p className="text-gray-500 text-base md:text-lg max-w-sm leading-relaxed">
              7 etapas sequenciais aplicadas diretamente no seu negócio ao longo de 60 dias.
            </p>
          </div>
        </div>

        {/* Conceito central */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          <div className="bg-gray-900 rounded-2xl p-10 flex flex-col justify-between min-h-[280px]">
            <div>
              <span className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full mb-6 uppercase tracking-widest">
                Conceito-chave
              </span>
              <h3 className="text-3xl md:text-4xl font-black text-white leading-tight mb-4">
                MAPA DE GARGALOS<br />E ALAVANCAS
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">
                Todo negócio tem pontos que travam o crescimento (gargalos) e pontos que podem acelerar resultados (alavancas). Nosso método começa identificando ambos.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-6">
            <div className="bg-red-50 border border-red-100 rounded-2xl p-8 flex items-start gap-5">
              <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-xl shrink-0">
                <i className="ri-link-unlink-m text-red-600 text-xl" />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-lg mb-1">GARGALOS</h4>
                <p className="text-gray-500 text-sm leading-relaxed">Onde sua empresa perde dinheiro, tempo e oportunidades todos os dias.</p>
              </div>
            </div>
            <div className="bg-emerald-50 border border-emerald-100 rounded-2xl p-8 flex items-start gap-5">
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-xl shrink-0">
                <i className="ri-rocket-2-line text-emerald-600 text-xl" />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-lg mb-1">ALAVANCAS</h4>
                <p className="text-gray-500 text-sm leading-relaxed">Onde pequenas mudanças geram grandes resultados de forma rápida.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Fluxo de etapas */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-7 gap-4">
          {etapas.map((etapa, i) => {
            const isBonus = i === etapas.length - 1;
            return (
            <div key={etapa.num} className="relative">
              {isBonus ? (
                <div className="relative rounded-2xl p-[2px] h-full"
                  style={{ background: 'linear-gradient(135deg, #f59e0b, #a5b4fc, #f59e0b)' }}>
                  <div className="rounded-2xl bg-amber-50 p-6 h-full flex flex-col">
                    {/* Badge bônus */}
                    <div className="flex items-center justify-between mb-3">
                      <span className="inline-flex items-center gap-1 bg-amber-400/30 border border-amber-400/50 text-amber-700 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-widest">
                        <i className="ri-gift-line text-[10px]" /> Bônus
                      </span>
                    </div>
                    <div className="flex items-center justify-between mb-4">
                      <span className="text-4xl font-black text-amber-400 opacity-50">{etapa.num}</span>
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-amber-100 border border-amber-300">
                        <i className={`${etapa.icon} text-amber-600 text-lg`} />
                      </div>
                    </div>
                    <h4 className="font-bold text-gray-900 text-base mb-2">{etapa.title}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{etapa.desc}</p>
                  </div>
                </div>
              ) : (
                <div className={`rounded-2xl border ${etapa.border} ${etapa.bg} p-6 h-full`}>
                  <div className="flex items-center justify-between mb-4">
                    <span className={`text-4xl font-black ${etapa.color} opacity-30`}>{etapa.num}</span>
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white">
                      <i className={`${etapa.icon} ${etapa.color} text-lg`} />
                    </div>
                  </div>
                  <h4 className="font-bold text-gray-900 text-base mb-2">{etapa.title}</h4>
                  <p className="text-gray-500 text-xs leading-relaxed">{etapa.desc}</p>
                </div>
              )}
              {i < etapas.length - 1 && (
                <div className="hidden xl:flex absolute -right-2 top-1/2 -translate-y-1/2 z-10 w-4 h-4 items-center justify-center">
                  <i className="ri-arrow-right-s-line text-gray-400 text-lg" />
                </div>
              )}
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
